import React from "react";

function TextInput (props: {
    labelName: string | undefined,
    inputName: string | undefined,
    value: string | undefined,
    placeholder: string | undefined,
    pattern?: string | undefined,
    errorMessage?: string | undefined,
    type: string,
    disabled?: boolean,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}){


    return (
        <div className="mb-2">
            <label>
                <p className="text-gray-500">
                    {props.labelName}
                </p>
            </label>
            <input className={`border-gray-400 w-full focus:border-blue-900 focus:outline-none border-2 p-2 min-h-[12px] shadow-[0_4px_10px_rgba(0,0,0,0.03)] font-normal transition-colors rounded-lg [&:not(:placeholder-shown):not(:focus):invalid~span]:block invalid:[&:not(:placeholder-shown):not(:focus)]:border-red-400 ${props.disabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                   name={props.inputName || ''}
                   onChange={props.onChange}
                   value={props.value || ''}
                   placeholder={props.placeholder}
                   type={props.type}
                   pattern={props.pattern}
                   disabled={props.disabled}
            />
            <span className="mt-1 hidden text-sm text-red-400">
                   {props.errorMessage}
            </span>
        </div>

    );
}

export default TextInput;